module.exports = __webpack_public_path__ + "static/37-3af7ec7b2074de5e4be51d0c8eb5ebde.jpg";